import { jsx as _jsx } from "react/jsx-runtime";
import { GalleryCounterBadge, GalleryCounterContainer } from './styles/gallery-counter.styled';
export const GalleryCounter = ({ index, total, class: className }) => {
    const content = total === 1 ? '1 foto' : `${index + 1}/${total}`;
    return (_jsx(GalleryCounterContainer, { className: className, children: _jsx(GalleryCounterBadge, { className: "PONCHO-gallery__counter__badge", children: content }) }));
};
